import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

export async function planModuleList(query?: { [key: string]: any }) {
	const queryString = formatQueryString(query);

	return await clientAxios.get(`plan/module/list${queryString}`);
}

export async function planModuleShow(item_id: string) {
	return await clientAxios.get(`plan/module/${item_id}/show`);
}

export async function planModuleCreate(payload: any) {
	return await clientAxios.post(`plan/module/create`, payload);
}

export async function planModulePatch(item_id: string, payload: Partial<any>) {
	return await clientAxios.patch(`plan/module/${item_id}/patch`, { payload });
}

export async function planModuleDelete(item_id: string) {
	return await clientAxios.del(`plan/module/${item_id}/delete`);
}
